'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');let

WaypointViewModelService=function(_BaseService){_inherits(WaypointViewModelService,_BaseService);_createClass(WaypointViewModelService,null,[{key:'$inject',get:function()
{return[]}}]);

function WaypointViewModelService(){_classCallCheck(this,WaypointViewModelService);return _possibleConstructorReturn(this,
_BaseService.call(this));
}WaypointViewModelService.prototype.

_getStatusAt=function _getStatusAt(time,statusTransitions){
for(let status of statusTransitions){
if(new Date(status.time).getTime()===new Date(time).getTime()){
return status;
}
}

return null;
};WaypointViewModelService.prototype.

_getStatusBefore=function _getStatusBefore(time,statusTransitions){
let lastStatus;

for(let status of statusTransitions){
if(new Date(status.time).getTime()===new Date(time).getTime()){
return lastStatus;
}

if(lastStatus===void 0||lastStatus.value!==status.value){
lastStatus=status;
}
}

return null;
};WaypointViewModelService.prototype.

_getDurationString=function _getDurationString(duration){
let{hours:hours,minutes:minutes}=duration;
let hoursString=hours>=1?`${hours} h`:null;
let minutesString=minutes>0?`${minutes} min`:null;

return _.compact([hoursString,minutesString]).join(' ');
};WaypointViewModelService.prototype.

_getAddressString=function _getAddressString(locationObject){
let{street:street,city:city,state:state,zip:zip}=locationObject;

return _.compact([street,city,state,zip]).join(', ');
};WaypointViewModelService.prototype.

createWaypointViewModelsForRoute=function createWaypointViewModelsForRoute(stops,statusTransitions,onBeginEdit){var _this2=this;
let stopWaypoints=stops.map(function(stop){
let startTime=new Date(stop.duration.start);

let addressString=_this2._getAddressString(stop.location);

let typeString=null;

if(stop.subType==='none'){
typeString='NotProvided';
}else if(stop.stopType==='rest'){
typeString='Rest stop';
}else if(stop.subType==='drophook'){
typeString='Drop and Hook';
}else if(stop.subType!=='none'){
typeString=_.upperFirst(stop.subType);
}

let durationString;

if(stop.subType==='none'){
durationString=null;
}else if(stop.subType==='drophook'){
durationString='45 min';
}else if(stop.subType==='load'||stop.subType==='unload'){
durationString='2h';
}else{
durationString=_this2._getDurationString(new TimeInterval(stop.duration).duration);
}

return{
name:_.exists(stop.location.name)?stop.location.name:null,
time:startTime,
timezone:stop.timezone,
address:addressString,
type:typeString,
duration:durationString,
isBreak:stop.stopType==='rest'};

});

let drivingWaypoints=[];

let lastWaypoint=null;
for(let waypoint of stopWaypoints){
let lastStatus=this._getStatusBefore(waypoint.time,statusTransitions);
let currentStatus=this._getStatusAt(waypoint.time,statusTransitions);

if(_.exists(lastStatus)&&lastStatus.value===2){
let statusInterval=new TimeInterval(lastStatus.time,currentStatus.time);

drivingWaypoints.push({
name:`Depart ${lastWaypoint.name||lastWaypoint.address}`,
time:new Date(lastStatus.time),
timezone:lastWaypoint.timezone,
address:null,
duration:this._getDurationString(statusInterval.duration),
type:'Drive',
isBreak:!1});

}
lastWaypoint=waypoint;
}

let combinedWaypoints=stopWaypoints.concat(drivingWaypoints);
let sortedCombinedWaypoints=_.sortBy(combinedWaypoints,function(wp){return new Date(wp.time).getTime()});

if(_.first(sortedCombinedWaypoints).type==='NotProvided'){
sortedCombinedWaypoints=_.tail(sortedCombinedWaypoints);
}

let originWaypoint=_.first(sortedCombinedWaypoints);
let destinationWaypoint=_.last(sortedCombinedWaypoints);

if(destinationWaypoint.type==='NotProvided'){
destinationWaypoint.type='Trip Complete';
}else
{
sortedCombinedWaypoints.push({
type:'Trip Complete',
name:destinationWaypoint.name,
address:destinationWaypoint.address,
time:new Date(_.last(stops).duration.end),
timezone:destinationWaypoint.timezone,
duration:null,
isBreak:!1});

destinationWaypoint=_.last(sortedCombinedWaypoints);
}

let editableWaypoints=[originWaypoint,destinationWaypoint];
for(let editableWaypoint of editableWaypoints){
editableWaypoint.beginEdit=function(){
let displayTimeWithoutSeconds=pulsarDate(editableWaypoint.time).fromTimeZoneOffsetToLocalOffset(editableWaypoint.timezone||'local');
displayTimeWithoutSeconds.setSeconds(0);
displayTimeWithoutSeconds.setMilliseconds(0);
editableWaypoint.edits={
address:editableWaypoint.address,
displayTime:displayTimeWithoutSeconds};

onBeginEdit(editableWaypoint);
};
}

return sortedCombinedWaypoints;
};return WaypointViewModelService}(BaseService);


module.exports=WaypointViewModelService;
//# sourceMappingURL=waypointViewModelService.js.map
